// Country-aware fallback map centre + zoom for empty search/heatmap states.
// Accepts ISO-ish country codes ("us", "ca", "gb") — case insensitive.
// Returns { lat, lng, zoom }. Unknown countries fall back to North America.

const CENTERS = {
  us: { lat: 39.8283, lng: -98.5795, zoom: 4 },   // Kansas-ish (geographic centre of contiguous US)
  ca: { lat: 56.1304, lng: -106.3468, zoom: 3 }, // centre of Canada
  gb: { lat: 54.5, lng: -3.0, zoom: 6 },          // rough centre of UK
};

const DEFAULT = CENTERS.us;

export function defaultMapCenter(country) {
  if (country == null) return DEFAULT;
  const key = String(country).toLowerCase();
  return CENTERS[key] || DEFAULT;
}
